import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './VettingSearchBar.css';

import VettingSearchIcon from '../Svg/VettingSearchIcon';
import {
  getAutoCompleteForAddress
} from '../../../Services/Services';
import VettingErrorIcon from "../../Common/Svg/VettingErrorIcon";
import SearchClearIcon from "../../Common/Svg/SearchClearIcon";
import {
  tagOnSectionDetailsSearchBarUse
} from "../../../Tagging/NewCustomerTagging"

const VettingSearchBar = (props) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const [autoCompleteTimeout, setAutoCompleteTimeout] = useState(null);
  const [addressAutoCompletes, setAddressAutoCompletes] = useState([]);
  const [showNoResultFound, setShowNoResultFound] = useState(false);

  const searchStringChangeHandler = event => {    
    if (event.target.value.length === 1) {
      tagOnSectionDetailsSearchBarUse();
    }
    const searchString = event.target.value;
    props.updateValue(searchString, props.inputIdentifier)
    if (searchString.trim() === "" || searchString.length < 3) {
      return setAddressAutoCompletes([]);
    }
    if (autoCompleteTimeout !== null) {
      clearTimeout(autoCompleteTimeout)
    }
    const timeOut = setTimeout(() => getAutoComplete(searchString), 400);
    setAutoCompleteTimeout(timeOut);
  }

  const getAutoComplete = searchString => {
    getAutoCompleteForAddress(searchString)
      .then(response => {
        if (response && response.result) {
          setAddressAutoCompletes(response.result.predictions);
          if(response.result.predictions.length > 0) {
            setShowNoResultFound(false);
          }else{
            setShowNoResultFound(true);
          }
        }
      }).catch(error => {
        console.dir(error);
      });
  }

  const clearSearchField = () => {
    props.updateValue("", props.inputIdentifier);
    setAddressAutoCompletes([]);
  }

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setAddressAutoCompletes([]);
          setShowNoResultFound(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return(
    <div 
      ref={wrapperRef}
      style={{width: "100%"}}
    >
      <div className={`vetting-search-bar-wrapper-container ${((addressAutoCompletes.length > 0) || showNoResultFound) ? 'newBorderRadius' : ''}`}>
        <VettingSearchIcon />
        <input
          type="text"
          className="vetting-search-text"
          placeholder="Search"
          value={props.value}
          onChange={(e) => searchStringChangeHandler(e)}
          automationid={`SalesLead_input_${props.automationidattr}searchInput_1`}
        />
        <div
          onClick = {()=> clearSearchField()} 
          style={{cursor: "pointer"}}>
          <SearchClearIcon/>
        </div>
        
        {
          addressAutoCompletes && addressAutoCompletes.length > 0 ?
            <ul className="search-result__list-container">
              {
                addressAutoCompletes.map((item, index) => {
                  return (
                    <li
                      onClick={() => { props.onAddressSelection(item.description); setAddressAutoCompletes([]) }}
                      key={index}
                      automationid={`SalesLead_li_${props.automationidattr}ListItem_${index}`}
                    >
                      {item.description}
                    </li>
                  )
                })
              }
            </ul>
            :
            showNoResultFound ? 
              <ul className="search-result__list-container">
                <li
                  key={"no-search-result"}
                  automationid={`SalesLead_li_ListItemNOResult_0`}
                >
                  No results found
                </li>
              </ul>
              :
              null
        }
      </div>
      {
        props?.errorMsg ?
          <div className={`vetting-invalid-msg-wrapper width100`}>
            <VettingErrorIcon />
            <span
              className="vetting-invalid-msg"
              automationid={`SalesLead_span_error${props.errorMsg}_1"`}
            >
              {props.errorMsg}
            </span>
          </div>
          :
          null
      }
    </div>
  )
}

VettingSearchBar.propTypes = {
  automationidattr: PropTypes.string,
  errorMsg: PropTypes.string,
  inputIdentifier: PropTypes.string,
  onAddressSelection: PropTypes.func,
  updateValue: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default VettingSearchBar;